'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasRealValue = exports.handleRenderLabel = exports.getRowDataByAtom = exports.getCompiled = exports.generateFunc = exports.FORM_CATEGORY = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vuFunctionParser = require('@ali/vu-function-parser');

var _vuFunctionParser2 = _interopRequireDefault(_vuFunctionParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FORM_CATEGORY = exports.FORM_CATEGORY = '表单';

var generateFunc = exports.generateFunc = _vuFunctionParser2.default;

var getCompiled = exports.getCompiled = function getCompiled(code) {
  if ((typeof code === 'undefined' ? 'undefined' : _typeof(code)) === 'object') {
    return code.compiled;
  }
  return code;
};

var getRowDataByAtom = exports.getRowDataByAtom = function getRowDataByAtom(rowDataAtom) {
  var rowData = {};
  if (rowDataAtom) {
    rowDataAtom.forEach(function (fieldAtom) {
      var fieldId = fieldAtom.getData('fieldId');
      var fieldValue = fieldAtom.getData('fieldData/value');
      if (fieldId) {
        rowData[fieldId] = fieldValue;
      }
    });
  }
  return rowData;
};

var handleRenderLabel = exports.handleRenderLabel = function handleRenderLabel(_ref, num) {
  var label = _ref.label,
      renderLabel = _ref.renderLabel,
      context = _ref.context;

  var trueLabel = num ? '' + label + num : label;
  if (renderLabel) {
    try {
      var func = generateFunc(renderLabel);
      trueLabel = func(trueLabel, context) || trueLabel;
    } catch (e) {
      window.console.error(e.message);
    }
  }
  return trueLabel;
};

var hasRealValue = exports.hasRealValue = function hasRealValue(value) {
  if (!value) {
    return false;
  }
  if (Array.isArray(value)) {
    return !!value.length;
  }
  if (Object.prototype.toString.call(value) === '[object Object]') {
    var vals = Object.values(value).filter(function (v) {
      return v;
    });
    return !!vals.length;
  }
  return !!value;
};